import { useCallback, useEffect, useMemo, useState } from "react";
import { erpFetch, getErpAuthState, isErpApiSuccess } from "../erpClient";

export function useHrmsBranches() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const tenantId = useMemo(() => {
    const u = getErpAuthState().user || {};
    const n = Number(u.tenant_id ?? u.tenantId);
    return Number.isFinite(n) && n > 0 ? n : null;
  }, []);

  const load = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const res = await erpFetch("/branch", {
        method: "POST",
        body: { type: "list" },
      });
      if (isErpApiSuccess(res) && Array.isArray(res?.data?.branches)) {
        setRows(res.data.branches);
      } else {
        setRows([]);
        setError(res?.message || "Could not load branches.");
      }
    } catch (e) {
      console.error(e);
      setRows([]);
      setError("Could not load branches.");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    void load();
  }, [load]);

  const options = useMemo(() => {
    const list = tenantId
      ? rows.filter((b) => Number(b.tenant_id) === Number(tenantId))
      : [...rows];
    return list
      .map((b) => ({
        value: Number(b.id),
        label: b.code ? `${b.name} (${b.code})` : String(b.name || ""),
      }))
      .filter((o) => Number.isFinite(o.value) && o.value > 0)
      .sort((a, b) => String(a.label).localeCompare(String(b.label)));
  }, [rows, tenantId]);

  return { branchOptions: options, loading, error, reload: load, tenantId };
}
